import { ACCESS_TOKEN, APP_CUSTOM_ERROR, REFRESH_TOKEN, ROLES } from "../../constants/AppVarConstants";
import { GET_MASTER_DATA } from "../api/config";
import {
  B2B_JOB_DETAILS_URL,
  B2B_LOGIN_URL,
  B2B_USER_PERSONALITY,
  B2B_TOPIC_SCORE,
  B2B_SCORE_BAND,
  CREATE_JOB_URL,
  EDIT_COMPANY_DETAILS_URL,
  EDIT_JOB_URL,
  FIND_JOB_BY_ID_URL,
  GET_APPLICANT_DETAILS_URL,
  GET_COMPANY_DETAILS_BY_ID_URL,
  GET_JOB_APPLICANTS_URL,
  GET_SHARE_PROFILE_APPLICANTS_URL,
  VALIDATE_SHARE_LINK_URL,
  VALIDATE_SHARE_PASSWORD_URL,
  GET_PERSONALITY_URL,
  JOBS_LISTING_URL,
  SIGNUP_ENQUIRY_URL,
  SAVE_JOB_VIEWS_URL,
  GET_ORGANIZATION_JOBS_URL,
  UPDATE_PRIMARY_STATUS_URL,
  UPDATE_REACHOUT_STATUS_URL,
  UPDATE_BEST_FIT_URL,
  UPDATE_COMPANY_DETAILS_BY_ID_URL,
  UPDATE_JOB_ACTION_URL,
  CREATE_COMMENT_URL,
  EDIT_COMMENT_URL,
  DELETE_COMMENT_URL,
  GET_COMMENTS_URL,
  COMMENT_APPLICANT_VIEW_SAVE_URL,
  CREATE_SHARE_LINK_URL,
  GET_APPLICANT_REPORT_URL,
  UPDATE_USER_VIDEOS,
  USER_COMPANY_CREATE_URL,
  USER_COMPANY_DETAILS_URL,
  RECOMMEND_JOB_TO_CANDIDATES_URL,
  GET_ALL_CANDIDATES_URL,
  GET_B2B_SKILL_MASTER_DATA_URL,
  GET_DEGREE_MASTER_DATA,
} from "../api/config";
import API_MIDDLEWARE from "../api/middleware";
import {
  SET_APPLICANT_DETAILS,
  SET_APPLICANT_DETAILS_LOADING,
  CLEAR_APPLICANT_DETAILS,
  SET_B2B_ACTIVE_TAB,
  SET_B2B_JOB_APPLICANTS,
  SET_B2B_JOB_DETAILS,
  SET_CLIENT_JOB_DETAILS,
  SET_FUNCTION_PERSONALITY,
  SET_JOB_DETAILS,
  SET_PERSONALITY,
  SET_USER_COMPANY_DETAILS,
  CLEAR_USER_COMPANY_DETAILS,
  UPDATE_BEST_FIT_STATUS,
  CREATE_COMMENT,
  EDIT_COMMENT,
  DELETE_COMMENT,
  SET_COMMENTS,
  CREATE_SHARE_LINK,
  SET_ORG_ACCOUNT_SETTLEMENTS,
  SET_APPLICANT_REPORT,
  SET_APPLICANT_PERSONALITY,
  SET_APPLICANT_TOPIC_SCORE,
  SET_APPLICANT_SCORE_BAND,
  VALIDATE_SHARE_LINK,
  VALIDATE_SHARE_PASSWORD,
} from "./actionTypes";
import { beginAjaxCall, endAjaxCall } from "./ajaxStatusActions";
import { setErrorMessage, setSuccessMessage, setUserInfo } from "./appActions";
import { dedupeJobApplicantRecords } from "../../utils/dedupeJobApplicants";

export const setB2BActiveTab = (value: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_B2B_ACTIVE_TAB, payload: value });
  };
};

export const clearUserCompanyDetails = (): any => {
  return (dispatch: any) => {
    dispatch({ type: CLEAR_USER_COMPANY_DETAILS });
  };
};

export const getJobDetails = (): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(JOBS_LISTING_URL, "POST", { "Content-Type": "application/json" }, {})
      .then((res) => {
        dispatch({ type: SET_JOB_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getB2BJobDetails = (jobId: string): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(B2B_JOB_DETAILS_URL(jobId), "POST", { "Content-Type": "application/json" }, {})
      .then((res) => {
        dispatch({ type: SET_B2B_JOB_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getB2BJobApplicants = (jobId: string, page = 1, fetchSize = 10000, searchQuery = ""): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      searchQuery,
      jobId: parseInt(jobId),
      page,
      fetchSize
    };
    API_MIDDLEWARE(GET_JOB_APPLICANTS_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        const result = res?.result;
        const payload =
          result && Array.isArray(result.records)
            ? { ...result, records: dedupeJobApplicantRecords(result.records) }
            : result;
        dispatch({ type: SET_B2B_JOB_APPLICANTS, payload });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const validateShareLink = (uniqueToken: string, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = { uniqueToken };
    API_MIDDLEWARE(VALIDATE_SHARE_LINK_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: VALIDATE_SHARE_LINK, payload: res?.result });
        dispatch(endAjaxCall());
        onSuccess(res?.result);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

export const validateSharePassword = (uniqueToken: string, password: string, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = { uniqueToken, password };
    API_MIDDLEWARE(VALIDATE_SHARE_PASSWORD_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: VALIDATE_SHARE_PASSWORD, payload: res?.result });
        dispatch(endAjaxCall());
        onSuccess(res?.result);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

export const getShareProfileApplicants = (uniqueToken: string): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    console.log('Calling share profile API with token:', uniqueToken);
    API_MIDDLEWARE(GET_SHARE_PROFILE_APPLICANTS_URL(uniqueToken), "GET", { "Content-Type": "application/json" }, null)
      .then((res) => {
        console.log('Share profile API response:', res);
        console.log('Share profile API result:', res?.result);
        
        // Handle different response structures
        let payload = res?.result;
        
        // If the response structure is different, try to normalize it
        if (res && !res.result && res.records) {
          // If the response has records directly
          payload = res;
        } else if (res && !res.result && res.data) {
          // If the response has data instead of result
          payload = res.data;
        }
        // Ensure the payload has the expected structure
        if (payload && !payload.records && Array.isArray(payload)) {
          // If payload is directly an array, wrap it in the expected structure
          payload = { records: payload, page: 1, hasNext: false };
        }

        if (payload && Array.isArray(payload.records)) {
          payload = { ...payload, records: dedupeJobApplicantRecords(payload.records) };
        }

        dispatch({ type: SET_B2B_JOB_APPLICANTS, payload });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        console.error('Share profile API error:', err);
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getJobApplicants = (): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_JOB_APPLICANTS_URL, "POST", { "Content-Type": "application/json" }, {})
      .then((res) => {
        dispatch({ type: SET_JOB_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const b2bLogin = (
  payload: { userName: string; otp: string },
  onSuccess: (res: any) => void,
  onError = () => {}
): any => {
  return (dispatch: any) => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(B2B_LOGIN_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        const { accessToken, refreshToken } = res.result;
        localStorage.setItem(ACCESS_TOKEN, accessToken);
        localStorage.setItem(REFRESH_TOKEN, refreshToken);
        localStorage.setItem(ROLES, res.result.roles);
        dispatch(setUserInfo(res?.result));
        dispatch(setSuccessMessage(res?.message ?? "Logged In"));
        onSuccess(res?.result);
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        onError();
      });
  };
};

export const signupEnquiry = (
  payload: {
    fullName: string;
    companyName: string;
    email: string;
    phoneNumber: string;
    enquiryTime: string;
  },
  onSuccess: (res: any) => void,
  onError = () => {}
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(SIGNUP_ENQUIRY_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((response) => {
        onSuccess(response);
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(endAjaxCall());
        onError();
      });
  };
};

type SuccessFn = (res?: any) => void;
type ErrorFn = (err?: any) => void;

export const getUserCompanyDetails = (
  {
    successFun = (() => {}) as SuccessFn,
    errorFun = (() => {}) as ErrorFn,
  }: { successFun?: SuccessFn; errorFun?: ErrorFn } = {}
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(USER_COMPANY_DETAILS_URL, "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch({ type: SET_USER_COMPANY_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
        successFun(res?.result);
      })
      .catch((err: any) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        errorFun(err);
      });
  };
};

export const getCompanyDetailsById = (
  companyId: number,
  {
    successFun = (() => {}) as SuccessFn,
    errorFun = (() => {}) as ErrorFn,
  }: { successFun?: SuccessFn; errorFun?: ErrorFn } = {}
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_COMPANY_DETAILS_BY_ID_URL(companyId), "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch({ type: SET_USER_COMPANY_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
        successFun(res?.result);
      })
      .catch((err: any) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        errorFun(err);
      });
  };
};

export const updateCompanyDetailsById = (
  companyId: number,
  payload: any,
  {
    successFun = (() => {}) as SuccessFn,
    errorFun = (() => {}) as ErrorFn,
  }: { successFun?: SuccessFn; errorFun?: ErrorFn } = {}
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(UPDATE_COMPANY_DETAILS_BY_ID_URL(companyId), "POST", { "Content-Type": "application/json" }, payload)
      .then((res: any) => {
        dispatch(endAjaxCall());
        dispatch(setSuccessMessage(res?.message ?? "Company details updated successfully!"));
        successFun(res?.result);
      })
      .catch((err: any) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        errorFun(err);
      });
  };
};


export const saveUserCompanyDetails = (payload: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(EDIT_COMPANY_DETAILS_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch(endAjaxCall());
        dispatch(setSuccessMessage(res?.message ?? "Details updated successfully!"));
        dispatch(getUserCompanyDetails());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const createCompany = (payload: any): any => {
  return async (dispatch: any) => {
    try {
    const payloadNew = {
      "name" : payload?.name,
      "email" : payload?.email,
      "contactNumber" : payload?.contactNumber,
      "industryOperateIn": payload?.industryOperateIn,
      "headquarter" : payload?.headquarter,
      "foundedIn" : payload?.foundedIn?.length>0?parseInt(payload?.foundedIn):0,
      "noOfEmployees" : payload?.noOfEmployees?.length>0?parseInt(payload?.noOfEmployees):0,
      "description" : payload?.description,
      "linkedinProfile" : payload?.linkedinProfile,
      "twitterProfile" : payload?.twitterProfile,
      "facebookProfile" : payload?.facebookProfile,
      "website" : payload?.website,
      "logoImagePath" : payload?.logo?.logo??"",
      "usersLimit": payload?.usersLimit?.length>0?parseInt(payload?.usersLimit):0,
    };
    dispatch(beginAjaxCall());
      const res = await API_MIDDLEWARE(USER_COMPANY_CREATE_URL, "POST", { "Content-Type": "application/json" }, payloadNew);

      dispatch(endAjaxCall());
      dispatch(setSuccessMessage(res?.message ?? "Created successfully!"));
      return res?.result;

    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return null;
    }
  };
};

export const getJobDetailsById = (jobId: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(FIND_JOB_BY_ID_URL(jobId), "POST", { "Content-Type": "application/json" }, {})
      .then((res: any) => {
        dispatch({ type: SET_CLIENT_JOB_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getApplicantDetails = (applicantId: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_APPLICANT_DETAILS_LOADING, payload: true });
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${GET_APPLICANT_DETAILS_URL}?applicant_id=${applicantId}`, "GET", {
      "Content-Type": "application/json",
    })
      .then((res: any) => {
        console.log("Applicant details:", res?.result);
        dispatch({ type: SET_APPLICANT_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch({ type: SET_APPLICANT_DETAILS_LOADING, payload: false });
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const clearApplicantDetails = (): any => {
  return (dispatch: any) => {
    dispatch({ type: CLEAR_APPLICANT_DETAILS });
  };
};

export const createJob = (payload: any, onSuccess: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(CREATE_JOB_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then(() => {
       dispatch(endAjaxCall());
        dispatch(setSuccessMessage("Job post created successfully!"));
        onSuccess();
      })
      .catch((err) => {
       dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
       dispatch(endAjaxCall());
      });
  };
};

export const editJob = (payload: any, onSuccess: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(EDIT_JOB_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then(() => {
        dispatch(endAjaxCall());
        dispatch(setSuccessMessage("Job post edited successfully!"));
        onSuccess();
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getPersonalityMaster = (): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_PERSONALITY_URL, "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch({ type: SET_PERSONALITY, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getFunctionPersonality = (func: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${GET_PERSONALITY_URL}?function=${func}`, "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch({ type: SET_FUNCTION_PERSONALITY, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const updateJobAction = (status: any, applicationId: any, onSuccess: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(
      `${UPDATE_JOB_ACTION_URL}?action=${status}&applicationId=${applicationId}`,
      "POST",
      { "Content-Type": "application/json" },
      {}
    )
      .then(() => {
        onSuccess();
        dispatch(setSuccessMessage("Status updated successfully!"));
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const updateVideoAction = (
  status: any,
  questionId: any,
  userId: any,
  onSuccess: any,
  onError?: () => void
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${UPDATE_USER_VIDEOS}?questionId=${questionId}&userId=${userId}&approvalStatus=${status}`, "GET", {
      "Content-Type": "application/json",
    })
      .then(() => {
        onSuccess();
        dispatch(setSuccessMessage("Status updated successfully!"));
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        onError?.();
      });
  };
};

/**
 * Common action to build report payload with optional filters
 * @param year - Optional year to filter by
 * @param month - Optional month to filter by
 * @param downloadExcel - Whether this is for downloading Excel
 * @param page - Page number (for fetching)
 * @param fetchSize - Fetch size (for fetching)
 */
export const buildReportPayload = (
  year = "",
  month = "",
  downloadExcel = false,
  page?: number,
  fetchSize?: number
): any => {
  const payload: any = {
    filters: {},
  };

  // Add pagination if provided (for data fetching, not download)
  if (page !== undefined && fetchSize !== undefined) {
    payload.page = page + 1;
    payload.fetchSize = fetchSize;
  }

  // Add download flag if needed
  if (downloadExcel) {
    payload.downloadExcel = true;
  }

  // Only add year and month if specific values are selected (not "All")
  if (year !== "") {
    payload.filters.year = parseInt(year);
  }
  if (month !== "") {
    payload.filters.month = parseInt(month);
  }

  return payload;
};

/**
 * Build client report payload with mc.created_at filter in this order:
 * 1. Custom range: startDate & endDate (end inclusive → backend uses mc.created_at < end+1)
 * 2. Same year + multiple months: year + months[]
 * 3. Single year + single month: year + month
 * 4. Year only: year
 * 5. Month only: month
 */
export interface ClientReportFiltersInput {
  startDate?: string | null;
  endDate?: string | null;
  year?: string;
  month?: number;
  months?: number[];
}

export const buildClientReportPayload = (
  filtersInput: ClientReportFiltersInput,
  downloadExcel = false,
  page?: number,
  fetchSize?: number
): any => {
  const payload: any = { filters: {} };

  if (page !== undefined && fetchSize !== undefined) {
    payload.page = page + 1;
    payload.fetchSize = fetchSize;
  }
  if (downloadExcel) {
    payload.downloadExcel = true;
  }

  const { startDate, endDate, year, month, months } = filtersInput;
  const yearNum = year !== undefined && year !== "" ? parseInt(year, 10) : undefined;
  const hasYear = yearNum !== undefined && !isNaN(yearNum);
  const monthList = Array.isArray(months) && months.length > 0 ? months : (month !== undefined && month >= 1 && month <= 12 ? [month] : []);

  // 1. Custom range – both startDate and endDate set, startDate <= endDate
  if (startDate && endDate && startDate <= endDate) {
    payload.filters.startDate = startDate;
    payload.filters.endDate = endDate;
    return payload;
  }

  // 2. Same year + multiple months
  if (hasYear && monthList.length > 1) {
    payload.filters.year = yearNum;
    payload.filters.months = monthList;
    return payload;
  }

  // 3. Single year + single month
  if (hasYear && monthList.length === 1) {
    payload.filters.year = yearNum;
    payload.filters.month = monthList[0];
    return payload;
  }

  // 4. Year only
  if (hasYear) {
    payload.filters.year = yearNum;
    return payload;
  }

  // 5. Month only
  if (monthList.length === 1) {
    payload.filters.month = monthList[0];
    return payload;
  }

  return payload;
};

export const updateBestFitStatus = (applicationId: number, isBestFit: boolean, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      applicationId,
      isBestFit
    };
    
    API_MIDDLEWARE(UPDATE_BEST_FIT_URL(applicationId), "PATCH", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: UPDATE_BEST_FIT_STATUS, payload: { applicationId, isBestFit } });
        dispatch(setSuccessMessage(isBestFit ? "Marked as Best Fit successfully!" : "Removed from Best Fit successfully!"));
        dispatch(endAjaxCall());
        onSuccess();
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) {
          onError();
        }
      });
  };
};

export const createComment = (jobId: number, message: string, receiverId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      jobId,
      message,
      receiverId
    };
    
    API_MIDDLEWARE(CREATE_COMMENT_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: CREATE_COMMENT, payload: res });
        dispatch(setSuccessMessage("Comment sent successfully!"));
        dispatch(endAjaxCall());
        onSuccess();
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) {
          onError();
        }
      });
  };
};

export const editComment = (commentId: number, message: string, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      commentId,
      message
    };
    
    API_MIDDLEWARE(EDIT_COMMENT_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: EDIT_COMMENT, payload: res });
        dispatch(setSuccessMessage("Comment updated successfully!"));
        dispatch(endAjaxCall());
        onSuccess();
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) {
          onError();
        }
      });
  };
};

export const deleteComment = (commentId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      commentId
    };
    
    API_MIDDLEWARE(DELETE_COMMENT_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: DELETE_COMMENT, payload: res });
        dispatch(setSuccessMessage("Comment deleted successfully!"));
        dispatch(endAjaxCall());
        onSuccess();
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) {
          onError();
        }
      });
  };
};

export const getComments = (jobId: number, applicantUserId: number, page = 1, fetchSize = 20): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      jobId,
      applicantUserId,
      page,
      fetchSize
    };
    
    API_MIDDLEWARE(GET_COMMENTS_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_COMMENTS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const createShareLink = (jobId: number, applicantIds: number[], allowedEmails: string[], expiryDays: string | null, password: string, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = { jobId, applicantIds, allowedEmails, expiryDays, password };
    API_MIDDLEWARE(CREATE_SHARE_LINK_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: CREATE_SHARE_LINK, payload: res });
        dispatch(setSuccessMessage("Share link created successfully!"));
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

export const getApplicantReport = (applicantId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_APPLICANT_REPORT_URL(applicantId), "GET", { "Content-Type": "application/json" }, null)
      .then((res) => {
        dispatch({ type: SET_APPLICANT_REPORT, payload: res });
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// New API actions for report data
export const getApplicantPersonality = (applicantId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${B2B_USER_PERSONALITY}?applicant_id=${applicantId}`, "GET", { "Content-Type": "application/json" }, null)
      .then((res) => {
        dispatch({ type: SET_APPLICANT_PERSONALITY, payload: res });
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

export const getApplicantTopicScore = (applicantId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${B2B_TOPIC_SCORE}?applicant_id=${applicantId}`, "GET", { "Content-Type": "application/json" }, null)
      .then((res) => {
        dispatch({ type: SET_APPLICANT_TOPIC_SCORE, payload: res });
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

export const getApplicantScoreBand = (applicantId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(`${B2B_SCORE_BAND}?applicant_id=${applicantId}`, "GET", { "Content-Type": "application/json" }, null)
      .then((res) => {
        dispatch({ type: SET_APPLICANT_SCORE_BAND, payload: res });
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

export const saveCommentApplicantView = (jobApplicantId: number, jobId: any, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      jobApplicantId,
      jobId
    };
    
    API_MIDDLEWARE(COMMENT_APPLICANT_VIEW_SAVE_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
      //  dispatch(setSuccessMessage("Comment view saved successfully!"));
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
       // dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// Save Job Views Action
export const saveJobViews = (jobId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(SAVE_JOB_VIEWS_URL, "POST", { "Content-Type": "application/json" }, { jobId })
      .then((res) => {
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// Get Organization Jobs Action
export const getOrganizationJobs = (companyId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_ORGANIZATION_JOBS_URL(companyId), "GET", { "Content-Type": "application/json" })
      .then((res) => {
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// Update Primary Status Action
export const updatePrimaryStatus = (applicationId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(UPDATE_PRIMARY_STATUS_URL, "POST", { "Content-Type": "application/json" }, { applicationId })
      .then((res) => {
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// Update Reachout Status Action
export const updateReachoutStatus = (applicationId: number, onSuccess: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(UPDATE_REACHOUT_STATUS_URL, "POST", { "Content-Type": "application/json" }, { applicationId })
      .then((res) => {
        dispatch(endAjaxCall());
        onSuccess(res);
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(); }
      });
  };
};

// Get All Candidates Action
export interface GetAllCandidatesFilters {
  degree?: string;
  course?: string;
  skills?: string;
  city?: string;
}

export const getAllCandidates = (
  jobId: number,
  searchQuery = "",
  filters?: GetAllCandidatesFilters,
  onSuccess?: any,
  onError?: any
): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload: any = {
      jobId,
      page: 1,
      limit: 1000, // Get a large number of candidates
      searchQuery: searchQuery || "",
    };
    if (filters) {
      if (filters.degree) payload.degree = filters.degree;
      if (filters.course) payload.course = filters.course;
      if (filters.skills) payload.skills = filters.skills;
      if (filters.city) payload.city = filters.city;
    }
    API_MIDDLEWARE(GET_ALL_CANDIDATES_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res: any) => {
        dispatch(endAjaxCall());
        if (onSuccess) {
          // Extract list: API returns { result: { records: [...] } }
          let candidates: any[] = [];
          if (res?.result?.records && Array.isArray(res.result.records)) {
            candidates = res.result.records;
          } else {
            const raw = res?.result ?? res;
            if (Array.isArray(raw)) {
              candidates = raw;
            } else if (raw && typeof raw === "object") {
              candidates =
                raw.records ??
                raw.data ??
                raw.candidates ??
                raw.content ??
                raw.list ??
                [];
            }
          }
          if (!Array.isArray(candidates)) {
            candidates = [];
          }
          // Filtering is done server-side via searchQuery in the request
          onSuccess(candidates);
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

// Get Course options by degree (for dependent filter dropdown)
export const getCourseOptions = (degree: string, onSuccess?: (courses: string[]) => void, onError?: any): any => {
  return (dispatch: any) => {
    if (!degree) {
      onSuccess?.([]);
      return;
    }
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_MASTER_DATA("COURSE_NAME"), "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch(endAjaxCall());
        if (onSuccess) {
          const raw = res?.result ?? res;
          const items = Array.isArray(raw) ? raw : raw?.courses ?? raw?.data ?? [];
          const allStrings = items.map((s: any) => (typeof s === "string" ? s : s?.name ?? s?.label ?? s?.value ?? String(s))).filter(Boolean);
          // Filter by degree: course names format "DEGREE_CourseName"
          const filtered = allStrings.filter(
            (c: string) => c?.toLowerCase().startsWith(`${degree.toLowerCase()}_`)
          ).map((c: string) => c.replace(new RegExp(`^${degree}_`, "i"), ""));
          onSuccess(filtered);
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

// Get Degree Master Data (for qualification filter dropdown)
export const getDegreeOptions = (onSuccess?: (qualifications: string[]) => void, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_DEGREE_MASTER_DATA, "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch(endAjaxCall());
        if (onSuccess) {
          const raw = res?.result ?? res;
          const items = Array.isArray(raw) ? raw : raw?.degrees ?? raw?.data ?? raw?.qualifications ?? [];
          const strings = items.map((s: any) => (typeof s === "string" ? s : s?.name ?? s?.label ?? s?.value ?? s?.degree ?? String(s))).filter(Boolean);
          onSuccess(strings);
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

// Get City Master Data (for filter dropdown)
export const getCityOptions = (onSuccess?: (cities: string[]) => void, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_MASTER_DATA("CITY"), "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch(endAjaxCall());
        if (onSuccess) {
          const raw = res?.result ?? res;
          const items = Array.isArray(raw) ? raw : raw?.cities ?? raw?.data ?? [];
          const strings = items.map((s: any) => (typeof s === "string" ? s : s?.name ?? s?.label ?? s?.value ?? String(s))).filter(Boolean);
          onSuccess(strings);
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

// Get B2B Skills Master Data (for filter dropdown)
export const getB2bSkills = (onSuccess?: (skills: string[]) => void, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_B2B_SKILL_MASTER_DATA_URL, "GET", { "Content-Type": "application/json" })
      .then((res: any) => {
        dispatch(endAjaxCall());
        if (onSuccess) {
          const raw = res?.result ?? res;
          const skills = Array.isArray(raw) ? raw : raw?.skills ?? raw?.data ?? [];
          const skillStrings = skills.map((s: any) => (typeof s === "string" ? s : s?.name ?? s?.label ?? s?.value ?? String(s))).filter(Boolean);
          onSuccess(skillStrings);
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};

// Recommend Job to Candidates Action
export const recommendJobToCandidates = (jobId: number, jobSeekerUserIds: number[], onSuccess?: any, onError?: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const payload = {
      jobId,
      jobSeekerUserIds,
    };
    API_MIDDLEWARE(RECOMMEND_JOB_TO_CANDIDATES_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then(() => {
        dispatch(endAjaxCall());
        dispatch(setSuccessMessage(`Job recommended to ${jobSeekerUserIds.length} candidate(s) successfully!`));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
        if (onError) { onError(err); }
      });
  };
};
